module.exports = __webpack_public_path__ + "static/media/Modern V Guitar Match off VR.044507c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Modern V Guitar Match off VR.mp3
// module id = b3pr
// module chunks = 12